var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeMediumNewDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7189 6.90641C15.4274 8.61496 15.4274 11.3851 13.7189 13.0936M5.62503 6.87498L9.55809 2.94192C9.95182 2.54819 10.625 2.82705 10.625 3.38386V16.6161C10.625 17.1729 9.95182 17.4518 9.55809 17.058L5.62503 13.125H3.75758C3.02479 13.125 2.33828 12.7029 2.14367 11.9964C1.96857 11.3608 1.87503 10.6913 1.87503 9.99998C1.87503 9.30866 1.96857 8.63918 2.14367 8.00351C2.33828 7.29704 3.02479 6.87498 3.75758 6.87498H5.62503Z",
    stroke: "white",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMediumNewDark);
export default __webpack_public_path__ + "static/media/volume-medium-new-dark.44029e6a7d90fd63ed395008f06f0c4d.svg";
export { ForwardRef as ReactComponent };